<div class="filter-container">
  <div>
    <pp-quick-filters data-testid="quick-filters" [(ppFilters)]="quickFilters" (ppFiltersChange)="handleQuickFilterChange()" />

    <div class="filter-container__advanced-filters" data-testid="filter-container-advanced-filters">
      <h6 class="filter-container__advanced-filters-title">
        {{ 'advanced_filters' | ppTranslate }}:
      </h6>
      <p class="filter-container__advanced-filters-text">
        {{ 'all_quick_filter_options_in_advanced' | ppTranslate }}
      </p>
      <pp-advanced-filters
        data-testid="advanced-filters"
        [ppWorkspaceId]="ppWorkspaceId()"
        [(ppFilters)]="advancedFilters"
        (ppFiltersChange)="handleAdvancedFilterChange()"
        [(ppOperator)]="advancedFilterOperator"
      />
    </div>
  </div>
</div>
